export const pagesDevicesCatalogEn = {
  catalog: {
    addCatalogItem: 'Add Catalog',
    description: 'Manage the catalog of devices available in your organization.',
    filter: {
      all: 'All',
      genrePlaceholder: 'Device Type',
      statusPlaceholder: 'Status'
    },
    filterPlaceholder: 'Search catalog',
    pageTitle: 'Device Catalog',
    tabs: {
      ACTIVE: 'Active',
      ALL: 'All',
      ARCHIVED: 'Archived',
      DRAFT: 'Draft'
    },
    title: 'Device Catalog'
  }
};